@if (notification$ | async; as notification) {
    <div class="notification" @notification>
        <div class="icon-container">
            @if (notification.icon !== 'spinner') {
                <i class="material-icons" @fade>{{ notification.icon }}</i>
            }
            @if (notification.icon === 'spinner') {
                <ogs-spinner @fade></ogs-spinner>
            }
        </div>
        <div class="text-container">
            @if (notification.title | async; as title) {
                <span class="title" @vshrink>{{ title }}</span>
            }
            @if (notification.subtitle | async; as subtitle) {
                <span class="subtitle" @vshrink>{{ subtitle }}</span>
            }
        </div>
        <div class="action-container">
            @if (notification.showReconnectButton) {
                <button class="btn-reconnect" (click)="onReconnectPressed()" @hshrink>
                    {{ 'comp.socket-overlay.reconnectButton' | translate }}
                </button>
            }
        </div>
    </div>
}
